export const SortOrder = {
  NONE: 'none',
  ASC: 'asc',
  DESC: 'desc',
};

export const NextSortOrder = {
  [SortOrder.NONE]: SortOrder.ASC,
  [SortOrder.ASC]: SortOrder.DESC,
  [SortOrder.DESC]: SortOrder.NONE,
};

export type SortOrderKey = keyof typeof SortOrder;
export type SortOrderValue = typeof SortOrder[SortOrderKey];
